module.exports = __webpack_public_path__ + "img/70ne.f6949a61.svg";